var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',{staticClass:"draggable-list-item d-flex"},[_c('div',{staticClass:"draggable-list-handle"},[_c('i',{staticClass:"fas fa-grip-vertical"})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }